import { getCurrentInstance } from '@vue/composition-api'
import type { CombinedVueInstance } from 'vue/types/vue'

/**
 * Gets the vue component proxy for access to things like $store that would normally have in options api
 */
export default (): CombinedVueInstance<Vue, object, object, object, Record<never, any>> | undefined => {
    const component = getCurrentInstance()
    return component?.proxy
}
